import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import {
  Component, Input, Output, EventEmitter, ViewChild,
  ElementRef, ChangeDetectorRef, AfterViewInit,
} from '@angular/core';
import * as firebase from "firebase";
import * as ResizeOption from 'ng2-imageupload';
import { animate, style, transition, trigger } from '@angular/animations';
import { DatePipe } from "@angular/common";
import { NotificationService } from "../../_services/notification.service";
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Http } from "@angular/http";
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { ElasticSearchService } from "../../_services/elastic-search.service";
import { Router, ActivatedRoute } from '@angular/router';
import { NgModel, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../_services/user.service';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { PhoneTakeRequestComponent } from '../../directive/phone-take-request/phone-take-request.component';
import { FirebaseError } from 'firebase';
import { ResizeOptions } from '../../_services/image-to-data-url/interfaces';
import { MatDialog, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { BadwordsService } from '../../_services/badwords.service';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from 'angularfire2/firestore';
import { WeeklyPostsService } from '../../_services/weeklyPosts.service';
import { PostService } from '../../_services/post.service';
import { DownloadImageService } from '../../_services/download-image.service';
import { ImageToDataUrlService } from '../../_services/image-to-data-url/image-to-data-url.service';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../_services/api.service';

@Component({
  selector: 'post-screen',
  templateUrl: './post-screen.component.html',
  styleUrls: ['./post-screen.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
          ]
        )])
  ],
  providers: [DatePipe]
})
export class PostScreenComponent implements AfterViewInit {
  storagePath: any = environment.storagePath;
  isRatingVerify = true;
  @Input() entityText: any;
  @Input() entityInf: any;
  @Input() editPost: any;
  @Input() revisedPost: any;
  @Input() editRevisedPost: any;
  @Input() searchProperty: string;
  @Input() gizlilik;
  @Input() whichHash: any;
  @Output() dismiss = new EventEmitter();
  @ViewChild('inputElement') public inputElement: NgModel;
  @ViewChild('postText') private postText: ElementRef;
  @ViewChild('phone') private phone: ElementRef;
  input = '';
  profilImage: any;
  inputText = '';
  inputHash = ' ';
  items = [];
  searchTerm = '';
  emptyItem = true;
  rateData = [];
  autoShow = true;
  auto = true;
  alert: any;
  sozlesme = false;
  test = false;
  step: any;
  backButton = true;
  prevPhone = false;
  blacklist = false;
  ipAddres: any;
  textError = false;
  reload = false;
  isStepPhoneVerify = false;
  somePlaceholder: string = "Deneyimini yaz.";

  averageClick = false;
  rateError: any;
  yourPoint = false;
  prevRegister = false;
  isMobile = false;
  loading: boolean;
  registerFormGroup: FormGroup;
  phoneFormGroup: FormGroup;
  deneme = false;
  tooltip = "Daha önce bu deneyimini değerlendirmiştin, istersen yeniden puanlayabilirsin.";
  // public mentionConfig = { triggerChar: '@' && '#' };
  public rating: any;
  public progress: number;
  postSettingsRadio = true;
  public postSettings: any = {
    isOnlyFriend: false,
    isNameSecret: false,
    isGlobal: true,
    isAllowComments: false
  };
  testValidateError;

  public validateError: any = {};
  user: any;
  slideList = {};
  database = firebase.database();
  model =
    [
      {
        title: "#markamaönerim",
        name: "Markana öneride bulun",
        value: false
      },
      {
        title: "#şikayetimvar",
        name: "Şikayetini paylaş",
        value: false
      },
      {
        title: "#benimtavsiyem",
        name: "Diğerleri için tavsiye bırak",
        value: false
      },
      {
        title: "#bunuçoksevdim",
        name: "Memnuniyetini paylaş",
        value: false
      }];
  categories = [
    {
      name: "Fiyat/Fayda"
    },
    {
      name: "Ürün Çeşitliliği & Tasarım"
    },
    {
      name: "Satış Hizmetleri"


    },
    {
      name: "Ürün Kalitesi"


    },
    {
      name: "Satış Sonrası Hizmetler"


    },
  ]



  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  files: any[] = [];
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  isUploading = false;
  progressStatus: string = "progress-bar-animated";
  userId = localStorage.getItem('currentUserId')
  length = 0;
  arrayNumber: any[] = [];
  resizeOptions: ResizeOption.ResizeOptions = {
    resizeMaxHeight: 750,
    resizeMaxWidth: 750
  };
  shareButtonText = 'İleri';
  backButtonText = 'Geri';
  back = false;
  back1 = false;
  tekrarSms = false;
  registerControl = false;
  phoneWaiter = true;
  firstCodeSend = false;
  emailError = false;
  isCodeSent = false;
  first = false;
  averageRate = 0;
  email: any;
  years = [];
  days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
    '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  months = [
    { month: 'Ocak', value: '01' },
    { month: 'Şubat', value: '02' },
    { month: 'Mart', value: '03' },
    { month: 'Nisan', value: '04' },
    { month: 'Mayıs', value: '05' },
    { month: 'Haziran', value: '06' },
    { month: 'Temmmuz', value: '07' },
    { month: 'Ağustos', value: '08' },
    { month: 'Eylül', value: '09' },
    { month: 'Ekim', value: '10' },
    { month: 'Kasım', value: '11' },
    { month: 'Aralık', value: '12' }];
  oldPoint: any;
  isSeenDialog = true;
  googleText: any;

  private subscription: Subscription = new Subscription();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private _el: ElementRef,
    private postService: PostService,
    private afs: AngularFirestore,
    private cd: ChangeDetectorRef,
    private downloadImageService: DownloadImageService,
    private scriptLoader: ScriptLoaderService,
    private dialog: MatDialog,
    private postSw: PostService,
    private userService: UserService,
    private imageResize: ImageToDataUrlService,
    private _formBuilder: FormBuilder,
    private afm: AngularFireDatabase,
    private httpclient: HttpClient,
    private weeklyPostservice: WeeklyPostsService,
    private elasticSearchService: ElasticSearchService,
    private apiService: ApiService,
    private _http: Http,
    private phoneAuthService: PhoneAuthenticationService,
    private badwordsService: BadwordsService,
    private notificationService: NotificationService,
    private badwordservice: BadwordsService) {
    this.subscription.add(this.userService.getUser().subscribe(user => this.user = user));

    this.getIpAdress();

    let dateNow = new Date();
    let currentYear = dateNow.getFullYear();
    for (let i = currentYear - 18; i > currentYear - 100; i--) {
      this.years.push(i);
    }
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;



  }

  // filter(val: string): string[] {
  //   if(this.items.length == 0) {
  //     return;
  //   }
  //   return this.items.filter(option =>
  //     option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  // }
  ngOnInit() {

    this.phoneFormGroup = this._formBuilder.group({
      phoneNumber: ['', Validators.required],
      code: [{ value: "", disabled: true }, Validators.required]
    });


    this.registerFormGroup = this._formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      day: ['', Validators.required],
      month: ['', Validators.required],
      year: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      profileImage: ['no-image.png'],
      agreement: [false, Validators.required]
    });



    this.loadRating();


    this.cd.markForCheck();

  }
  phoneGuard() {
    if (this.user.phoneNumber) {
      return true;
    }
    else {
      this.requestPhone();
      return false;
    }
  }
  prev1() {
    this.step = this.step - 1;

    this.back = true;

  }
  prevSignup() {
    this.step = 3;
    this.prevRegister = false;
    this.prevPhone = false;

  }

  isEdit() {
    if (this.editPost || this.revisedPost) {
      this.test = true;
      return false;

    }
    else {
      return true;
    }
  }


  getAverageRate() {
    this.averageClick = true;


    if (this.rating.criterias.filter(data => data.point != 0).length === 5) {
      this.rateError = '';
      ;
    }
    try {
      let total = this.rating.criterias.reduce((a, b) => {
        return a + b.point
      }, 0);
      return total / (this.rating.criterias.filter(criteria => criteria.point != 0).length || 1)
    } catch (e) {
      return 0;
    }

    // var rate: any = {};
    // Object.assign(rate, rating);
    // let sum = 0;
    // let avg = 0;
    // let uniqueName = rate.uniqueName;
    // if (rate.criterias) {
    //   let array = rate.criterias.filter(criteria => {
    //     sum += criteria.point;
    //     return criteria.point != 0;
    //   });
    //   if (array.length != 0) {
    //     avg = sum / array.length;
    //   }
    // }
    // //this.averageRate[rate.uniqueName] = { rate: avg, uniqueName: rate.uniqueName };
    // return avg;
  }
  next() {

    if (this.inputText.trim().length < 10) {
      this.deneme = true;
      this.testValidateError = '* Deneyimin nasıldı ? Görüşünü detaylı yazarak diğerlerine yardımcı ol.';
    }
    else {
      this.testValidateError = '';
      this.step = 2;
    }
  }
  next4() {


    if (this.inputText.trim().length < 10) {
      this.deneme = true;
      this.testValidateError = '* Deneyimin nasıldı ? Görüşünü detaylı yazarak diğerlerine yardımcı ol.';
    }
    else {
      this.testValidateError = '';
      this.step = 3;

    }
  }
  prev() {
    this.step = this.step - 1;
    this.isRatingVerify = true;
  }
  prev2() {
    this.step = 2;
    this.auto = false;

  }
  prev3() {
    this.step = 1;
  }

  selectSecret(value) {
    if (value == "isOnlyFriend") {
      this.postSettings.isOnlyFriend = true;
      this.postSettings.isGlobal = false;
    } else {
      this.postSettings.isOnlyFriend = false;
      this.postSettings.isGlobal = true;
    }
  }
  handleSelection(emoji) {
    let caretPos = this.postText.nativeElement.selectionStart;
    this.inputText = this.inputText.substring(0, caretPos) + " " + emoji + " " + this.inputText.substring(caretPos);
  }

  setTopic(index: number) {

    this.test = true;
    let caretPos = this.postText.nativeElement.selectionStart;



    if (!this.model[index].value) {
      this.inputHash = this.model[index].title + " " + this.inputText.substring(caretPos);
      this.cd.markForCheck();
    }
    if (index === 1) {
      this.somePlaceholder = "Deneyimin nasıldı, yoksa seni üzdüler mi? Görüşlerini detaylı yazarak sesini hemen duyurabilirsin.";
    }
    if (index === 2) {
      this.somePlaceholder = "Bende çok tavsiye var, deneyimlerimi aktarmam gerek diyorsan tam yerindesin! Hemen paylaş, herkes faydalansın."
    }
    if (index === 3) {
      this.somePlaceholder = "Bu deneyim bir harika dostum dediğini duyar gibiyiz. Hemen paylaş, herkes bilsin."
    }
    if (index === 0) {
      this.somePlaceholder = "Eleştiren değil geliştiren misin yoksa? Markana öner bir sonraki deneyimin daha iyi olsun."
    }
  }

  slide(i) {
    this.slideList[i] = !this.slideList[i];
    try {
      if (!this.rating.criterias[i + 1].point) this.slideList[i + 1] = true
    } catch (e) { }
  }
  checkBadWord() {
    if (this.step !== 3) {
      this.step = this.step + 1;

    }


    this.subscription = this.badwordsService.getBadwords().subscribe(badwords => {
      this.blacklist = false;
      badwords.forEach(badword => {
        if (this.registerFormGroup.get('username').value == badword) {
          this.registerFormGroup.get('username').setErrors({ 'badWord': true });
          this.blacklist = true;
        }
      })
      if (this.blacklist == false) {
        this.register()
      }
    })
  }
  phonenumber() {
    this.tekrarSms = true;
    this.isCodeSent = false;
    // this.phoneFormGroup.reset();
    this.phone.nativeElement.value = null;
    this.phoneFormGroup.get('code').disable();
  }
  validatePhoneNumber() {
    if (!this.isCodeSent) {
      console.log("validatephone")
      this.firstCodeSend = true;
      this.phoneAuthService.sendOtp(this.phoneFormGroup.get("phoneNumber").value)
        .then(res => {
          this.loading = false;
          this.isCodeSent = true;
          this.phoneFormGroup.get("code").enable();
          return;
          // this.phoneFormGroup.get("phoneNumber").setErrors(null);
        }).catch(err => {
          this.phoneFormGroup.get("phoneNumber").setErrors({ invalidPhoneNumber: true });
          this.loading = false;
          return;
        });
      return;
    }
    if (!this.phoneAuthService.confirm(this.phoneFormGroup.get("code").value)) {
      this.phoneFormGroup.get("code").setErrors({ invalidCode: true });
      this.loading = false;


      return;
    }
    if (this.phoneAuthService.confirm(this.phoneFormGroup.get("code").value)) {

      this.registerControl = true;
      this.phoneWaiter = false;
      this.register();





    }
  }
  a(b) {
    return b.replace(/[^0-9]/g, '');
  }
  request(option) {

    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendWelcomenew', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  sameMail() {
    this.alert = { type: "danger", message: "E-posta adresin, platformda başka bir kullanıcı tarafından kullanılıyor." };
    this.loading = false;
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: this.alert.message,
        type: "update"
      }
    });
    this.cd.markForCheck();
  }
  async register(model?) {
    console.log("register")
    console.log(this.isStepPhoneVerify)
    console.log(this.rating.uniqueName)
    this.sozlesme = true;
    this.loading = true;
    const update = {};
    var userInfo = model ? model : this.registerFormGroup.value;
    try { delete userInfo.password } catch (e) { }
    userInfo.birthday = {
      day: this.registerFormGroup.get("day").value,
      month: this.registerFormGroup.get("month").value,
      year: this.registerFormGroup.get("year").value
    }
    let modifyDate = Date.now();
    let welcomePost: any = {
      text: "Hoşgeldin " + userInfo.firstname + " " + userInfo.lastname + " 😃",
      modifyDate: modifyDate,
      settings: {
        isOnlyFriend: false,
        isNameSecret: false,
        isGlobal: true,
        isAllowComments: false
      },
      author: {
        firstname: "bigadvice",
        lastname: "",
        username: "bigadvice",
        profileImage: "UserIcon.png"
      },
      valueOf: 0,
      order: -1 * modifyDate,
      username: userInfo.username.replace(/\s/g, "").toLowerCase()
    };
    userInfo.isEmailVerified = false;
    userInfo.username = userInfo.username.replace(/\s/g, "").toLowerCase();
    userInfo.joinDate = Date.now();
    userInfo.userInfoPoints = {
      birthday: 0,
      city: 0,
      education: 0,
      about: 0,
      job: 0,
      gender: 0,
      importContact: 0,
      interested: 0
    };
    userInfo.isSecret = false;
    userInfo.level = 0;
    userInfo.point = {
      totalPoint: 10
    }
    console.log("ggg")
    userInfo.phoneNumber = this.phoneFormGroup.get("phoneNumber").value;
    if (this.rating.uniqueName === 'koctas') {
      if (this.blacklist == false)
        this.rating.userRate = this.averageRate;
      let userInput: string = this.inputText;
      if (userInput.indexOf("@" + this.rating.uniqueName + " ") < 0) {
        userInput = "@" + this.rating.uniqueName + " " + this.inputText;
      }


      userInfo.postsInWait = {
        rating: this.rating,
        files: this.files,
        text: userInput + ' ' + this.inputHash,
        postSettings: this.postSettings
      }
      let entitiesUserInfo = {
        name: userInfo.firstname + ' ' + userInfo.lastname,
        profileImage: userInfo.profileImage,
        searchTerm: (userInfo.username + userInfo.firstname + userInfo.lastname).toLowerCase().replace(/\s/g, ""),
        type: 'user',
        uniqueName: userInfo.username

      }
      if (this.userId) {
        console.log("userıd var")

        // this.step = 4;

        if (!this.registerControl) {
          userInfo.email = this.email;
          this.user = this.registerFormGroup.value;
          this.afs.collection('users').doc(this.userId).set(userInfo).then(() => {
            this.afs.collection('entities').doc(this.userId).set(entitiesUserInfo);
          }).then(() => {
          })

            .then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
            .then(() => {
              localStorage.setItem("currentUserId", this.userId);
              this.userService.setUser(this.userId);

              var users = {
                userKey: this.userId,
                agreement: userInfo.agreement || null,
                birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
                totalPoint: 10,
                username: userInfo.username,
                email: userInfo.email,
                firstname: userInfo.firstname,
                isEmailVerified: userInfo.isEmailVerified || null,
                isSecret: userInfo.isSecret || null,
                joinDate: this.dateFormat(new Date(userInfo.joinDate)),
                lastname: userInfo.lastname,
                level: userInfo.level,
                city: userInfo.city || null,
                phoneNumber: userInfo.phoneNumber || null,
                education: userInfo.education || null,
                gender: userInfo.gender || null,
                job: userInfo.job || null,
                profileImage: userInfo.profileImage || null,
                following: userInfo.following ? userInfo.following.length : 0,
                followers: userInfo.followers ? userInfo.followers.length : 0
              }
              const option = {
                data: {
                  customToken: this.userId,
                  email: userInfo.email,
                  firstname: userInfo.username,
                  name: userInfo.firstname
                }
              }

              this.request(option);



              this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(() => {
                this.afs.collection('welcomePosts').doc(this.userId).set(welcomePost);
              });
              // this.router.navigate(["/home"], { queryParams: { message: "landingMessage" } });
            });
        }
        if (this.registerControl) {
          this.user = this.registerFormGroup.value;
          this.isStepPhoneVerify = true;

          let postDetails = {
            rating: this.rating,
            files: this.files,
            text: userInput + ' ' + this.inputHash,
            postSettings: this.postSettings
          };
          let user = this.user;

          // this.afs.collection('posts').add(postDetails).then((postId) => {
          //   let postKey = postId.id;

          return this.postService.sharePost({ ...postDetails, user, userId: this.userId }).then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
            .then(() => {

              var users = {
                userKey: this.userId,
                agreement: userInfo.agreement || null,
                birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
                totalPoint: 10,
                username: userInfo.username,
                email: userInfo.email,
                firstname: userInfo.firstname,
                isEmailVerified: userInfo.isEmailVerified || null,
                isSecret: userInfo.isSecret || null,
                joinDate: this.dateFormat(new Date(userInfo.joinDate)),
                lastname: userInfo.lastname,
                level: userInfo.level,
                city: userInfo.city || null,
                phoneNumber: userInfo.phoneNumber || null,
                education: userInfo.education || null,
                gender: userInfo.gender || null,
                job: userInfo.job || null,
                profileImage: userInfo.profileImage || null,
                following: userInfo.following ? userInfo.following.length : 0,
                followers: userInfo.followers ? userInfo.followers.length : 0

              }


              this.afs.collection('users').doc(this.userId).update({ phoneNumber: this.phoneFormGroup.get('phoneNumber').value });
              this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise()
                .then(() => {
                  this.dismiss.emit(true);
                  this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                    this.router.navigate(['/home'], { queryParams: { message: "landingMessage" } });
                  });


                });


            })




        }
      }
      else if (!this.userId) {
        console.log("user ıd yokkkkkkk")
        firebase.auth().fetchProvidersForEmail(this.registerFormGroup.get('email').value).then((a) => {
          if (a.length != 0) {
            this.prevRegister = true;
            this.sameMail();
            return;
          }
          else {


            this.prevPhone = true;
            this.prevRegister = false;
            if (!this.registerControl) {
              console.log("this.register yok")


              var createAuth = firebase.auth().createUserWithEmailAndPassword(this.registerFormGroup.get("email").value, this.registerFormGroup.get("password").value).catch(error => {
                this.authErrors(error);
                return;
              })
              var createUser = createAuth.then((data: any) => {

                userInfo.isNewRegistered = false;
                this.afs.collection('users').doc(data.uid).set(userInfo).then(() => {
                  this.afs.collection('entities').doc(data.uid).set(entitiesUserInfo);
                })
                  .then(() => {
                    let postDetails = userInfo.postsInWait
                    let user = userInfo;
                    let userId = data.uid;
                    this.userId = data.uid;
                    localStorage.setItem("currentUserId", userId);
                    this.userService.setUser(userId);

                    // this.afs.collection('posts').add({}).then((postId) => {

                    //   let postKey = postId.id;

                    // return this.postService.sharePost({ ...postDetails, user, userId }).then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))

                  })
                  .then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
                  .then(() => {
                    var users = {
                      userKey: this.userId,
                      agreement: userInfo.agreement || null,
                      birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
                      totalPoint: 10,
                      username: userInfo.username,
                      email: userInfo.email,
                      firstname: userInfo.firstname,
                      isEmailVerified: userInfo.isEmailVerified || null,
                      isSecret: userInfo.isSecret || null,
                      joinDate: this.dateFormat(new Date(userInfo.joinDate)),
                      lastname: userInfo.lastname,
                      level: userInfo.level,
                      city: userInfo.city || null,
                      phoneNumber: userInfo.phoneNumber || null,
                      education: userInfo.education || null,
                      gender: userInfo.gender || null,
                      job: userInfo.job || null,
                      profileImage: userInfo.profileImage || null,
                      following: userInfo.following ? userInfo.following.length : 0,
                      followers: userInfo.followers ? userInfo.followers.length : 0
                    }

                    const option = {
                      data: {
                        customToken: this.userId,
                        email: userInfo.email,
                        firstname: userInfo.username,
                        name: userInfo.firstname
                      }
                    }

                    this.request(option);
                    this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(() => {
                      this.afs.collection('welcomePosts').doc(this.userId).set(welcomePost);

                    })

                  });
              });
            }
          }
        });
      }
    }

    if (!this.isStepPhoneVerify && this.rating.uniqueName !== 'koctas') {
      console.log(this.isStepPhoneVerify, 'phone-verify')
      if (this.blacklist == false)
        this.rating.userRate = this.averageRate;
      let userInput: string = this.inputText;
      if (userInput.indexOf("@" + this.rating.uniqueName + " ") < 0) {
        userInput = "@" + this.rating.uniqueName + " " + this.inputText;
      }


      userInfo.postsInWait = {
        rating: this.rating,
        files: this.files,
        text: userInput + ' ' + this.inputHash,
        postSettings: this.postSettings
      }
      let entitiesUserInfo = {
        name: userInfo.firstname + ' ' + userInfo.lastname,
        profileImage: userInfo.profileImage,
        searchTerm: (userInfo.username + userInfo.firstname + userInfo.lastname).toLowerCase().replace(/\s/g, ""),
        type: 'user',
        uniqueName: userInfo.username

      }
      console.log(this.userId, 'user-id')
      if (this.userId) {

        this.prevRegister = false;
        this.prevPhone = true;
        this.isStepPhoneVerify = true;
        if (!this.registerControl) {
          userInfo.email = this.email;
          this.user = this.registerFormGroup.value;
          this.afs.collection('users').doc(this.userId).set(userInfo).then(() => {
            this.afs.collection('entities').doc(this.userId).set(entitiesUserInfo);
          }).then(() => {
            let postDetails = {
              rating: this.rating,
              files: this.files,
              text: userInput + ' ' + this.inputHash,
              postSettings: this.postSettings
            };
            let user = this.user;
            // this.afs.collection('posts').add(postDetails).then((postId) => {
            //   let postKey = postId.id;

            return this.postService.sharePost({ ...postDetails, user, userId: this.userId }).then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))


          })
            .then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
            .then(() => {
              localStorage.setItem("currentUserId", this.userId);
              this.userService.setUser(this.userId);

              var users = {
                userKey: this.userId,
                agreement: userInfo.agreement || null,
                birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
                totalPoint: 10,
                username: userInfo.username,
                email: userInfo.email,
                firstname: userInfo.firstname,
                isEmailVerified: userInfo.isEmailVerified || null,
                isSecret: userInfo.isSecret || null,
                joinDate: this.dateFormat(new Date(userInfo.joinDate)),
                lastname: userInfo.lastname,
                level: userInfo.level,
                city: userInfo.city || null,
                phoneNumber: userInfo.phoneNumber || null,
                education: userInfo.education || null,
                gender: userInfo.gender || null,
                job: userInfo.job || null,
                profileImage: userInfo.profileImage || null,
                following: userInfo.following ? userInfo.following.length : 0,
                followers: userInfo.followers ? userInfo.followers.length : 0
              }
              const option = {
                data: {
                  customToken: this.userId,
                  email: userInfo.email,
                  firstname: userInfo.username,
                  name: userInfo.firstname
                }
              }

              this.request(option);



              this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(() => {
                this.afs.collection('welcomePosts').doc(this.userId).set(welcomePost);
              });
              // this.router.navigate(["/home"], { queryParams: { message: "landingMessage" } });
            });
        }
      }
      else if (!this.userId) {
        firebase.auth().fetchProvidersForEmail(this.registerFormGroup.get('email').value).then((a) => {
          if (a.length != 0) {
            this.prevRegister = true;
            this.sameMail();
            return;
          }
          else {

            this.isStepPhoneVerify = true;
            this.prevPhone = true;
            this.prevRegister = false;
            if (!this.registerControl) {
              console.log("register-control")


              var createAuth = firebase.auth().createUserWithEmailAndPassword(this.registerFormGroup.get("email").value, this.registerFormGroup.get("password").value).catch(error => {
                this.authErrors(error);
                return;
              })
              var createUser = createAuth.then((data: any) => {

                userInfo.isNewRegistered = false;
                this.afs.collection('users').doc(data.uid).set(userInfo).then(() => {
                  this.afs.collection('entities').doc(data.uid).set(entitiesUserInfo);
                })
                  .then(() => {
                    let postDetails = userInfo.postsInWait
                    let user = userInfo;
                    let userId = data.uid;
                    this.userId = data.uid;
                    localStorage.setItem("currentUserId", userId);
                    this.userService.setUser(userId);

                    // this.afs.collection('posts').add({}).then((postId) => {

                    //   let postKey = postId.id;

                    return this.postService.sharePost({ ...postDetails, user, userId }).then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
                      .then(() => {
                        console.log("post attı")
                      })
                  })
                  .then(() => this.scriptLoader.load('body', 'assets/js/landing-conversion.js'))
                  .then(() => {
                    var users = {
                      userKey: this.userId,
                      agreement: userInfo.agreement || null,
                      birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
                      totalPoint: 10,
                      username: userInfo.username,
                      email: userInfo.email,
                      firstname: userInfo.firstname,
                      isEmailVerified: userInfo.isEmailVerified || null,
                      isSecret: userInfo.isSecret || null,
                      joinDate: this.dateFormat(new Date(userInfo.joinDate)),
                      lastname: userInfo.lastname,
                      level: userInfo.level,
                      city: userInfo.city || null,
                      phoneNumber: userInfo.phoneNumber || null,
                      education: userInfo.education || null,
                      gender: userInfo.gender || null,
                      job: userInfo.job || null,
                      profileImage: userInfo.profileImage || null,
                      following: userInfo.following ? userInfo.following.length : 0,
                      followers: userInfo.followers ? userInfo.followers.length : 0
                    }

                    const option = {
                      data: {
                        customToken: this.userId,
                        email: userInfo.email,
                        firstname: userInfo.username,
                        name: userInfo.firstname
                      }
                    }

                    this.request(option);
                    this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(() => {
                      this.afs.collection('welcomePosts').doc(this.userId).set(welcomePost);

                    })

                  });
              });
            }
          }
        });
      }
    }
    else if (this.isStepPhoneVerify && this.rating.uniqueName !== 'koctas') {

      var users = {
        userKey: this.userId,
        agreement: userInfo.agreement || null,
        birthday: this.dateFormat(new Date(userInfo.birthday.year + "/" + userInfo.birthday.month + "/" + userInfo.birthday.day)),
        totalPoint: 10,
        username: userInfo.username,
        email: userInfo.email,
        firstname: userInfo.firstname,
        isEmailVerified: userInfo.isEmailVerified || null,
        isSecret: userInfo.isSecret || null,
        joinDate: this.dateFormat(new Date(userInfo.joinDate)),
        lastname: userInfo.lastname,
        level: userInfo.level,
        city: userInfo.city || null,
        phoneNumber: userInfo.phoneNumber || null,
        education: userInfo.education || null,
        gender: userInfo.gender || null,
        job: userInfo.job || null,
        profileImage: userInfo.profileImage || null,
        following: userInfo.following ? userInfo.following.length : 0,
        followers: userInfo.followers ? userInfo.followers.length : 0

      }


      this.afs.collection('users').doc(this.userId).update({ phoneNumber: this.phoneFormGroup.get('phoneNumber').value })
      this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise()
        .then(() => {

          console.log("kapandı")
          this.dismiss.emit(true);
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/home'], { queryParams: { message: "landingMessage" } });
          });
        });



    }

  }


  warningPostAndShare() {


    this.validateError = '';
    if (this.isSeenDialog && this.getAverageRate() === 1) {
      this.shareButtonText = 'Tekrar gönder';
      this.backButton = false;
      this.isSeenDialog = false;
    }
    else if (this.rating.criterias.filter(data => data.point != 0).length != 5 || this.rating.criterias.every(data => !data.point)) {

      this.rateError = "* Deneyimini paylaşmak için lütfen hepsini puanla";
    }

    else if (this.userId) {
      this.rateError = '';

      this.testValidateError = '';
      this.post();
    }
    else if (!this.userId) {
      console.log("user Id yok")
      this.registerStep();
    }
  }
  registerStep() {
    this.prevRegister = true;
  }
  signUpWithGoogle() {

    let loginProvider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.signUpWithSocialIcon(res.user);
    }).catch(err => this.authErrors(err))

  }

  signUpWithFacebook() {

    let loginProvider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.signUpWithSocialIcon(res.user);
    }).catch(err => this.authErrors(err))

  }

  handleize(text) {
    return text.toString().toLowerCase()
      .replace(/\s/g, '')
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u');
  }
  signUpWithSocialIcon(data) {
    return this.afs.collection('users').doc(data.uid).ref.get().then(snap => {
      if (!snap.exists) {
        this.googleText = "Kullanıcı adı ve doğum tarihi bilgilerinizi doldurunuz.";
        this.first = true;
        this.loading = true;
        this.email = data.email;
        this.registerFormGroup.patchValue({
          firstname: data.displayName.substring(0, data.displayName.lastIndexOf(' ')),
          lastname: data.displayName.substring(data.displayName.lastIndexOf(' ')),
          email: data.email,
          username: this.handleize(data.displayName)
        }, { onlySelf: true });
        this.registerFormGroup.get("password").disable();
        this.registerFormGroup.get("confirmPassword").disable();
        this.registerFormGroup.get("email").disable();

        this.userId = data.uid;
        this.cd.markForCheck();
        return this.downloadUserProfileImage(data.photoURL).then(image => {
          if (image) {
            this.registerFormGroup.patchValue({ profileImage: data.uid + '%2FprofileImage' }, { onlySelf: true });
            // this.registerFormGroup.setValue({ profileImage: data.uid + '%2FprofileImage' });
          }
        })
      } else {
        this.emailError = true;

        // this.dialog.open(SaveMessageComponent, {
        //   width: '400px',
        //   panelClass: 'dialogCss',

        //   data: {
        //     message: "Bu e-posta adresi zaten kullanılıyor.",
        //     type: "update"
        //   }
        // });
      }

    })
  }
  downloadUserProfileImage(imageURL): Promise<any> {
    console.log(" profile");
    return new Promise((resolve, reject) => {
      this.subscription.add(this.downloadImageService.getImage(imageURL).subscribe(image => {
        this.downloadImageService.upload(new Blob([new Uint8Array(image)]), this.userId).then(res => {
          let resizeOptions: ResizeOptions[] = [{
            maxHeight: 128,
            maxWidth: 128
          }, {
            maxHeight: 64,
            maxWidth: 64
          }, {
            maxHeight: 45,
            maxWidth: 45
          }];
          let count = 0;
          resizeOptions.forEach(option => {
            this.imageResize.readFiles([this.blobToFile(new Blob([new Uint8Array(image)]), "profileImage_" + option.maxHeight + "_thumb")], { resize: option }, imageResult => {
              if (imageResult.error) alert(imageResult.error);
              let src = imageResult.resized
                && imageResult.resized.dataURL
                || imageResult.dataURL;
              firebase.storage().ref('/files/' + this.userId).child("profileImage_" + option.maxHeight + "_thumb").putString(src, "data_url").then(() => {
                if (++count == resizeOptions.length) resolve(this.userId + '%2FprofileImage');
              });
            });
          })
        }).catch(err => {
          reject(err);
        });
      }))
    });
  }
  public blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

  authErrors(err: FirebaseError) {
    switch (err.code) {
      case "auth/user-not-found": this.alert = { type: "danger", message: "Emin misin? Platformda böyle bir kullanıcı yok." }; break;
      case "auth/weak-password": this.alert = { type: "danger", message: "Oluşturacağın şifre en az 6 karakterden oluşmalıdır." }; break;
      case "auth/invalid-email": this.alert = { type: "danger", message: "E-posta adresin hatalı" }; break;
      case "auth/wrong-password": this.alert = { type: "danger", message: "Parolan geçersiz veya henüz şifren yok." }; break;
      case "auth/account-exists-with-different-credential": this.alert = { type: "danger", message: "Bu e-posta adresi zaten kullanılıyor." }; break;
      case "auth/email-already-in-use": this.alert = { type: "danger", message: "E-posta adresin, platformda başka bir kullanıcı tarafından kullanılıyor." }; break;
    }
    this.loading = false;
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: this.alert.message,
        type: "update"
      }
    });
    // let ref = this.snackBar.open(this.alert.message, "Kapat");
    // ref.onAction().subscribe(() => {
    //   ref.dismiss();
    // });
    this.cd.markForCheck();
  }
  async post() {

    // this.inputText.split(" ").forEach(a=>{
    //   if(a.startsWith('53')){
    //     var str=a.substr(4,8)
    //    console.log( this.inputText.replace(str,'****'));
    //   }
    // })



    if (this.input.replace(/\s/g, '') == '') {


      this.rating = null;
      try { document.getElementsByClassName("modal-dialog")[0].classList.remove("big-model"); } catch (e) { }
      this.inputElement.control.setErrors({ 'valid': false });
      return;
    }
    if (this.userId == null) {
      this.router.navigate(["/auth"]);
      this.dismiss.emit(true);
      return;
    }
    // if(this.inputText.trim().length < 10){
    //   this.inputElement.control.setErrors({ 'valid': false });
    //   this.validateError = { code: "notRated", message: "* Deneyimin nasıldı ? Görüşünü detaylı yazarak diğerlerine yardımcı ol. " }
    //   return;
    // }


    if (!this.rating) {
      this.inputElement.control.setErrors({ 'valid': false });
      this.validateError = { code: "notRated", message: "* Lütfen markanı seçerek görüşünü paylaş." }
      this.testValidateError = '';
      return;
    }

    else if (this.rating.criterias.every(data => data.point == 0) || this.rating.criterias.every(data => data.point === undefined) || this.rating.criterias.every(data => !data.point)) {
      if (this.inputElement) {
        this.inputElement.control.setErrors({ 'valid': false });
      }



      this.validateError = { code: "notScored", message: "* Sesini duyurmaya çok az kaldı. Deneyimini objektif şekilde paylaşman için, değerleme kriterleri oluşturduk. Hemen puanla, sen de platformdaki diğer kullanıcılarla paylaş." }
      return;
    }
    else if (!this.rating.criterias.every(data => data.point != 0) || !this.rating.criterias.every(data => data.point != undefined) || !this.rating.criterias.every(data => data.point)) {
      if (this.inputElement) {
        this.inputElement.control.setErrors({ 'valid': false });
      }

      this.validateError = { code: "missingScoring", message: "* Her kriter için puan vererek diğerlerinin senin deneyiminden faydalanmasına yardım et." }
      return;
    }
    else {



      this.inputText = '@' + this.searchTerm + ' ' + this.inputText + ' ' + this.inputHash;

      this.dismiss.emit(true);
      if (this.editPost) {


        this.postOutWork();
      } else {
        if (!this.user.myPosts) {

          const sendEmail = this.userService.sendEmail({ email: this.user.email, type: "FirstPostEmail", userId: this.userId });
          sendEmail.then(() => this.getPoint());
          await this.postOutWork();

        } else {

          this.getPoint();
          await this.postOutWork();


        }
      }
      this.cd.markForCheck();
    }
  }

  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddres = data.json() }).subscribe());
  }

  changeTextCategory(string) {
    return string
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/-/g, '')
      .replace(/\./g, '_')
      .replace(/\'/g, '')
      .replace(/\s/g, '_').toLowerCase();
  }

  rateUpdate() {
    if (this.rating.type === 'brand' && this.rating.isRateable) {

      this.afs.collection(this.rating.type + 's').ref.where('uniqueName', '==', this.rating.uniqueName).get().then(brandID => {
        this.afs.collection(this.rating.type + 's').doc(brandID.docs[0].id).collection('userRates').doc(this.userId).set({
          criteria: this.rating.criterias,
          modifyDate: Date.now(),
          rate: this.averageRate
        });

      })

    }
    if (this.rating.type === 'product') {
      this.afs.collection(this.rating.type + 's').ref.where('uniqueName', '==', this.rating.uniqueName).get().then(brandID => {
        this.afs.collection(this.rating.type + 's').doc(brandID.docs[0].id).collection('userRates').doc(this.userId).set({
          criteria: this.rating.criterias,
          modifyDate: Date.now(),
          rate: this.averageRate
        });

      }).then(() => {
        this.afs.collection('brands').ref.where('uniqueName', '==', this.rating.brand).get().then(brandId => {
          this.afs.collection('brands').doc(brandId.docs[0].id).collection('categories').ref.where('name', '==', this.rating.category).get().then(categoryId => {
            if (categoryId)
              this.afs.collection('brands').doc(brandId.docs[0].id).collection('categories').doc(categoryId.docs[0].id).update({ name: this.rating.category })
          })
        })
      })



    }
  }

  async postOutWork() {

    const newPost: any = {};
    let postKey: any;
    let dateNew = Date.now();

    const offset = await this.afm.list('.info/serverTimeOffset').$ref.once('value');

    this.rating.userRate = this.averageRate;

    let html = this.inputText;

    const hashtags = this.inputText.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig)
      ? this.inputText.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) : [];
    const products = this.inputText.match(/@[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig)
      ? this.inputText.match(/@[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) : [];
    newPost.author = {
      firstname: this.user.firstname || '',
      lastname: this.user.lastname || '',
      profileImage: this.user.profileImage || '',
      username: this.user.username || '',
      level: this.user.level ? this.user.level : 0
    },
      newPost.files = this.files,
      newPost.innerText = this.inputText,
      newPost.ipAdress = this.ipAddres,
      newPost.modifyDate = dateNew,
      newPost.rating = this.rating,
      newPost.settings = this.postSettings,
      newPost.text = html,
      newPost.valueOf = 0,
      newPost.valueOf_ModifyDate = -1 * parseInt(Date.now() + offset.val()),
      newPost.user = this.userId

    if (this.editPost) {


      let editHashtag = this.editPost.innerText.split('#');

      if (editHashtag[editHashtag.length - 1]) {
        this.inputText = this.inputText + '' + '#' + editHashtag[editHashtag.length - 1];
      }
      html = this.inputText;
      const hashtags = this.inputText.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig)
        ? this.inputText.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) : [];

      this.afs.collection('posts').doc(this.editPost.id).update({
        text: firebase.firestore.FieldValue.delete()
      })

      this.elasticSearchService.getProducts(products, (hits: any[]) => {
        let dataType;
        let isRateable;
        hits.filter((data, index) => {
          dataType = data.type;
          isRateable = data.type == 'brand' ? data.isRateable : false;
          if (data.type == "user" || "brand" || "product") {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          }
          else {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.type + '/' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          }

        });

        hashtags.forEach(item => {

          item = item.substring(1);

          html = html.replace("#" + item, '<a href="hashtag/' + item.toLowerCase() + '">#' + item + '</a>');


          this.afs.collection('posts').doc(this.editPost.id).update({
            ['tag-' + item.toLocaleLowerCase()]: true,
            isEdit: true,
            innerText: this.inputText,
            rating: this.rating,
            files: this.files,
            settings: this.postSettings

          });
          this.cd.markForCheck();
        })

        this.afs.collection('posts').doc(this.editPost.id).update({
          text: html

        })
        this.cd.markForCheck();
      })
      this.cd.markForCheck();

    }

    else {
      if (this.revisedPost) {


        newPost.revisedPost = this.revisedPost ? true : null;
        newPost.revisedPostKey = this.revisedPost ? this.editRevisedPost.id : null;
        newPost.answers = this.revisedPost ? this.editRevisedPost.answers : null;
        newPost.isAnswered = this.editRevisedPost.isAnswered || null;
        newPost.oldPoint = this.revisedPost ? this.oldPoint : null;
        this.afs.collection('posts').doc(this.editRevisedPost.id).update({ revisedPost: true });
      }

      this.afs.collection('posts').add(newPost)
        .then((a) => {
          postKey = a.id;


          this.elasticSearchService.getProducts(products, (hits: any[]) => {
            let dataType;
            let isRateable;
            hits.filter((data, index) => {
              dataType = data.type;
              isRateable = data.type == 'brand' ? data.isRateable : false;

              if (data.type == "user" || "brand" || "product") {


                html = html.replace("@" + data.uniqueName, '<a href="' + data.uniqueName + '">@' + data.uniqueName + '</a>');
                this.afs.collection('posts').doc(postKey).update({ ['mention-' + data.uniqueName]: true });
              }
              else {
                html = html.replace("@" + data.uniqueName, '<a href="' + data.type + '/' + data.uniqueName + '">@' + data.uniqueName + '</a>');
              }

            });

            hashtags.forEach(item => {
              item = item.substring(1);
              html = html.replace("#" + item, '<a href="hashtag/' + item.toLowerCase() + '">#' + item + '</a>');

              this.afs.collection('posts').doc(postKey).update({
                ['tag-' + item.toLocaleLowerCase()]: true
              }).then(() => {
                this.weeklyPostservice.weeklyPosts(item, newPost);
              })

            })
            this.afs.collection('posts').doc(postKey).update({
              text: html,
              order: -1 * (dateNew + offset.val())
            }).then(() => {
              this.postSw.postCount(this.userId, this.rating);
            }).then(() => {
              if ((dataType == "product" || (dataType == "brand" && isRateable)) && !this.editPost) {


                this.getBadgePoint(this.rating.category);

              }
            });



          });


          this.afs.collection('logs').add({
            userId: this.user.id,
            date: new Date(),
            type: 'post',
            postId: postKey,
            ipAddress: this.ipAddres,
            url: 'bigadvice.com'
          });



        });
    }

    this.afs.collection(this.rating.type + 's').ref.where('uniqueName', '==', this.rating.uniqueName).get().then(brandID => {
      this.afs.collection(this.rating.type + 's').doc(brandID.docs[0].id)
        .collection('categories').ref.where('name', '==', 'Genel').get().then(snap => {
          if (snap.empty) {
            this.afs.collection(this.rating.type + 's').doc(brandID.docs[0].id).collection('categories').add({ name: 'Genel' });
          }
        });
    }).then(() => {
      this.rateUpdate();

    });



  }

  async getBadgePoint(categoryName: string) {
    let category;

    await this.afs.collection('categories').ref.where('name', '==', categoryName).get().then((snap => {
      snap.forEach(data => {
        category = data.data();
      })
    }))
    try {
      let x;
      let y;
      this.afs.collection('users').doc(this.userId).ref.get().then((data => {
        if (data.data().point[category.uniqueName]) {

          x = {
            [category.uniqueName]: {
              point: data.data().point[category.uniqueName].point + 10
            },
            totalPoint: data.data().point.totalPoint
          }
          const a = Object.entries(data.data().point).filter(b => {
            return b[0] !== category.uniqueName
          })
          a.forEach(z => {
            y = {
              [z[0]]: z[1]
            }

            Object.assign(x, y);
          });
        }
        else {
          x = {
            [category.uniqueName]: {
              point: 10
            },
            totalPoint: data.data().point.totalPoint
          }
          Object.assign(x, data.data().point);

        }
      })).then(() => {

        this.afs.collection('users').doc(this.userId).update({ point: x })
      })
        .then(() => {

          this.afs.collection('users').doc(this.userId).ref.get().then((data => {
            const userCatPoint = data.data().point[category.uniqueName].point;
            const badgePoint = 150;
            // const userBadges = data.data().badges[category.uniqueName];

            if (userCatPoint === badgePoint) {
              if (this.user.point[category.uniqueName]) {
                this.dialog.open(SaveMessageComponent, {
                  width: '400px',
                  data: {
                    title: 'Tebrikler!',
                    type: "badge",
                    image: "categoryIcons/" + category.uniqueName + ".png",
                    content: category.name + ' kategorisinde uzmanlık kazandın.'
                  }
                });


              }
            }

            if (userCatPoint === 150) {

              this.afs.collection('users').doc(this.user.id).ref.get().then((data => {
                let y = {
                  [category.uniqueName]: true,

                }
                Object.assign(y, data.data().badges);
                this.afs.collection('users').doc(this.user.id).update({ badges: y });
                if (this.reload) {
                  this.router.navigate(['/home']);

                }
              }))

            }
          }))

        });



      if (this.reload) {
        this.router.navigate(['/home']);

      }
    } catch (e) { }
  }

  requestPhone() {
    if (this.userId) {
      this.dialog.open(PhoneTakeRequestComponent, {
        width: 'auto',
        height: '80%',
        data: {
          title: 'Tebrikler!',
          type: "badge",
          image: "categoryIcons/" + "category.uniqueName" + ".png",
          content: "category.name" + ' kategorisinde uzmanlık kazandın.'
        }
      });
    }
    else {
      this.router.navigate(['/auth']);
    }
  }

  labelSetTopic(index) {
    this.test = true;
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {
      } else {
        let caretPos = this.postText.nativeElement.selectionStart;
        if (!this.model[index].value) {
          this.inputHash =
            this.inputText.substring(0, caretPos) + " " + this.model[index].title + " " + this.inputText.substring(caretPos);
          this.cd.markForCheck();
        }
      }
    }
  }

  getPoint() {
    this.user.point.totalPoint += 10;
    setTimeout(() => {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: '10 puan kazanarak' + ' ' + this.user.point.totalPoint + ' ' + 'puana yükseldin!',
          type: 'post'
        }
      });

    }, 800);

    this.afs.collection('users').doc(this.user.id).update({ point: this.user.point })
  }

  getGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  videoUpload(event) {
    let file = event.target.files[0];
    var storageRef = firebase.storage().ref();
    let newFileName = this.getGUID();
    var uploadTask = storageRef.child('files/' + newFileName).put(file);
    this.upload(uploadTask, () => {
      let media = {
        type: "video",
        name: newFileName
      };
      this.files.push(media);
      var videos: any[] = Array.from(this._el.nativeElement.getElementsByTagName("video"));
      videos.filter(video => {
        video.removeAttribute("controls");
      });
    });
  }

  deleteFile(name) {
    firebase.storage().ref().child('files/' + name).delete();
    this.files = this.files.filter(data => {
      return data.name != name;
    });
  }

  photoUpload(imageResult) {
    console.log(imageResult);
    let src = imageResult.resized && imageResult.resized.dataURL || imageResult.dataURL;
    var storageRef = firebase.storage().ref();
    let newFileName = this.getGUID();
    console.log(src, "srccc");
    var uploadTask = storageRef.child('files/' + newFileName).putString(src, "data_url");
    this.upload(uploadTask, () => {
      let media = {
        type: "image",
        name: newFileName
      };
      this.files.push(media);
    });
  }

  upload(uploadTask, callback) {
    this.isUploading = true;
    uploadTask.then(() => callback());
    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on('state_changed', (snapshot: firebase.storage.UploadTaskSnapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          break;
      }
    }, (error: firebase.FirebaseError) => {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          break;

        case 'storage/canceled':
          // User canceled the upload
          break;
        case 'storage/unknown':
          // Unknown error occurred, inspect error.serverResponse
          break;
      }
    }, () => {
      this.isUploading = false;
    });
  }



  public ngAfterViewInit() {
    if (this.editPost) {

      this.testAuto(this.editPost.rating);
      this.cd.markForCheck();
      var a = this.editPost.innerText.split("@" + this.editPost.rating.uniqueName);
      this.inputText = a[1];
      this.inputText = this.inputText.replace('#şikayetimvar', '');
      this.inputText = this.inputText.replace('#benimtavsiyem', '');
      this.inputText = this.inputText.replace('#markamaönerim', '');
      this.inputText = this.inputText.replace('#bunuçoksevdim', '');
      this.input = this.editPost.rating.name;
      Object.assign(this.postSettings, this.editPost.settings);
      if (this.editPost.rating) {
        this.rating = {};
        if (this.editPost.answeredDate)
          this.oldPoint = this.editPost.rating.userRate;
        Object.assign(this.rating, this.editPost.rating);
        this.averageRate = this.getAverageRate();
      }
      if (this.editPost.files)
        this.files = this.editPost.files;
      this.fakeInputKeyUp();
      this.inputFocus();
    }

    else if (this.entityInf) {
      console.log(this.entityInf)

      this.rateData = this.entityInf;
      this.rating = this.entityInf;
      this.searchTerm = this.entityInf.uniqueName;
      this.input = this.entityInf.name;
      this.inputText = '';
      this.fakeInputKeyUp();
      this.inputFocus();
      this.loadRating();
    }
    else if (this.whichHash) {
      this.reload = true;

    }
    else if (this.editRevisedPost) {


      this.inputText = '';
      this.input = this.editRevisedPost.rating.name;
      this.rateData = this.editRevisedPost.rating;
      this.rating = this.editRevisedPost.rating;
      this.searchTerm = this.editRevisedPost.rating.uniqueName;
      Object.assign(this.postSettings, this.editRevisedPost.settings);
      if (this.editRevisedPost.rating) {
        this.rating = {};
        if (this.editRevisedPost.answeredDate)
          this.oldPoint = this.editRevisedPost.rating.userRate;
        Object.assign(this.rating, this.editRevisedPost.rating);
        this.averageRate = this.getAverageRate();
      }
      // if (this.editRevisedPost.files)
      //   this.files = this.editRevisedPost.files;
      this.fakeInputKeyUp();
      this.inputFocus();
      this.loadRating();
      this.cd.markForCheck();
    }
    // else if (this.entityInf) {
    //   this.testAuto(this.entityInf);
    //   this.input = this.entityInf.name;
    //   this.inputText = '';
    //   this.fakeInputKeyUp();
    //   this.inputFocus();
    // }

  }

  public fakeInputKeyUp() {
    let keyboardEvent = document.createEvent("KeyboardEvent");
    let initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";
    keyboardEvent[initMethod](
      "keyup", // event type : keydown, keyup, keypress
      true, // bubbles
      true, // cancelable
      window, // viewArg: should be window
      false, // ctrlKeyArg
      false, // altKeyArg
      false, // shiftKeyArg
      false, // metaKeyArg
      8, // keyCodeArg : unsigned long the virtual key code, else 0
    );
    this.inputKeyUp(keyboardEvent)
  }

  public inputKeyUp(event: any) {
    if (event.which === 9 || event.keyCode === 9 ||
      event.which === 38 || event.keyCode === 38 ||
      event.which === 40 || event.keyCode === 40) {
      return;
    }


    // this.model.filter(data => {
    //   data.value = this.input.indexOf(data.title) > -1;
    // });
    if (this.input.length > 2) {
      let searchTerm = this.input.replace(/\s|@|,|'|\.|\#/g, '').toLowerCase().trim();
      this.elasticSearchService.searchBy("SearchTerm", { "searchTerm": searchTerm })
        .toPromise().then((hits: any[]) => {
          this.items = [];
          hits.filter(data => {

            if (data.type == 'brand' || data.type == 'product') {
              this.items.push(data);
            }
          });
        })

    }
    // if (this.input && this.input.length > 2) {
    //   this.loadRating();
    // }
  }
  public inputKeyUpText(event: any) {
    if (event.which === 9 || event.keyCode === 9 ||
      event.which === 38 || event.keyCode === 38 ||
      event.which === 40 || event.keyCode === 40) {
      return;
    }
  }

  public loadRating() {
    this.step = this.step + 1;



    if (this.searchTerm.length != 0) {


      // if (!isRatingSame) {
      this.rating = this.rateData;


      this.averageRate = 0;

      this.afs.collection(this.rating.type + 's').ref.where('uniqueName', '==', this.rating.uniqueName).get().then((data => {
        if (this.userId) {
          this.afs.collection(this.rating.type + 's').doc(data.docs[0].id).collection('userRates').doc(this.userId).ref.get().then((rate => {
            try {

              this.rating.criterias.forEach((data, index) => {
                data.point = rate.data().criteria[index].point;
              });
              this.averageRate = rate.data().rate;
              this.yourPoint = true;

              this.rating.criterias.filter((criteria, i) => this.slideList[i] = false);

              // document.getElementsByClassName("modal-dialog")[0].classList.add("big-model");

            }
            catch (e) {


              if (this.rating)

                //  document.getElementsByClassName("modal-dialog")[0].classList.add("big-model");
                this.rating.criterias.filter((criteria, i) => this.slideList[i] = i == 0);
            }

          }))
        }
      }));


    }
    else if (this.searchTerm.length == 0) {

      this.rating = null;
      try { document.getElementsByClassName("modal-dialog")[0].classList.remove("big-model"); } catch (e) { }
    }


  }

  public inputFocus() {
    document.getElementById("postText").classList.add("active");
  }

  public selectSuggestion(selection) {
    if (selection.type == "advice") {
      this.dismiss.emit(false);
      this.router.navigate(['/product-advice']);
    } else {

      this.loadRating();
    }
  }
  productAdvice() {
    console.log("bastı")
    this.dismiss.emit(false);
    this.router.navigate(['/product-advice']);
  }

  public inputBlur() {
    // let ev = new KeyboardEvent(" ");
    // this.inputKeyUp(ev);
    setTimeout(() => {
      try {
        document.getElementById("10").classList.remove("active");
      } catch (e) { }
    }, 80);

  }
  // inputKeyUp2() {
  //     if (data.length > 2) {
  //       let searchTerm = data.replace(/\s|@|,|'|\.|\#/g, '').toLowerCase().trim();
  //       this.elasticSearchService.searchBy("SearchTerm", { "searchTerm": searchTerm })
  //         .subscribe((hits: any[]) => {
  //           if(this.items.length != 10){
  //             this.items = hits
  //           }
  //   })

  //   if (this.searchTerm.length == 0) {
  //     this.items = [];
  //     return;
  //   }

  //         if (this.searchTerm) {
  //           this.loadRating();
  //         }
  //       }
  // }
  testAuto(item) {
    console.log("ggggg")
    this.items = [];
    this.searchTerm = item.uniqueName;
    this.rateData = item;
    this.rating = item;
    this.input = item.name;

    this.loadRating();

  }
  // public blurInputElement() {
  //   let event = new KeyboardEvent(" ");
  //   this.inputKeyUp(event);
  // }
  public ngOnDestroy(): void {
    /*
     * magic kicks in here: All subscriptions which were added
     * with "subscription.add" are canceled too!
     */
    try {
      this.subscription.unsubscribe();
    } catch (e) { }
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/post-screen/post-screen.component.ts